var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7714 0C17.4387 0 18.0787 0.265091 18.5506 0.736957C19.0225 1.20882 19.2875 1.84881 19.2875 2.51613V4.19355H17.6101V14.2581C17.6101 14.9254 17.345 15.5654 16.8732 16.0372C16.4013 16.5091 15.7613 16.7742 15.094 16.7742H3.35207C2.68475 16.7742 2.04476 16.5091 1.57289 16.0372C1.10103 15.5654 0.835938 14.9254 0.835938 14.2581V12.5806H14.2553V14.2581C14.2553 14.4635 14.3307 14.6618 14.4672 14.8153C14.6038 14.9688 14.7919 15.0669 14.9959 15.0909L15.094 15.0968C15.2994 15.0967 15.4977 15.0213 15.6512 14.8848C15.8047 14.7483 15.9028 14.5602 15.9268 14.3562L15.9327 14.2581V1.67742H5.02949C4.82406 1.67745 4.62578 1.75287 4.47227 1.88937C4.31876 2.02588 4.22068 2.21398 4.19665 2.418L4.19078 2.51613V10.9032H2.51336V2.51613C2.51336 1.84881 2.77845 1.20882 3.25031 0.736957C3.72218 0.265091 4.36217 0 5.02949 0H16.7714Z",
    fill: "#6BC66F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOrders);
export default __webpack_public_path__ + "static/media/card-orders.b1093f4914fa02ec92effd55213ca6e1.svg";
export { ForwardRef as ReactComponent };